import { fetchRequestWithTypes } from './index.js';

// PATCH an investor application.

export const PATCH_INVESTOR_APPLICATION_REQUEST = 'PATCH_INVESTOR_APPLICATION_REQUEST';
export const PATCH_INVESTOR_APPLICATION_SUCCESS = 'PATCH_INVESTOR_APPLICATION_SUCCESS';
export const PATCH_INVESTOR_APPLICATION_ERRORED = 'PATCH_INVESTOR_APPLICATION_ERRORED';

export const patchInvestorApplication = (body) =>
	fetchRequestWithTypes({
		types: [
			PATCH_INVESTOR_APPLICATION_REQUEST,
			PATCH_INVESTOR_APPLICATION_SUCCESS,
			PATCH_INVESTOR_APPLICATION_ERRORED,
		],
		request: {
			method: 'PATCH',
			path: '/api/v1/users/:uuid/investor_application',
			body,
		},
	});

// Returns all retire specific application questions.
// https://staging.stsh.io/documentation/1.0/investor_applications/retire_questions.html

export const GET_RETIRE_APPLICATION_REQUEST = 'GET_RETIRE_APPLICATION_REQUEST';
export const GET_RETIRE_APPLICATION_SUCCESS = 'GET_RETIRE_APPLICATION_SUCCESS';
export const GET_RETIRE_APPLICATION_ERRORED = 'GET_RETIRE_APPLICATION_ERRORED';

export const getRetireApplication = () =>
	fetchRequestWithTypes({
		types: [
			GET_RETIRE_APPLICATION_REQUEST,
			GET_RETIRE_APPLICATION_SUCCESS,
			GET_RETIRE_APPLICATION_ERRORED,
		],
		request: {
			method: 'GET',
			path: '/api/v1/investor_applications/retire_questions',
		},
	});
